import React from "react";

function Icon({fill="#CE000E",width="26",
  height="26"}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 26 26"
    >
      <mask
        id="mask0_4907_15784"
        style={{ maskType: "alpha" }}
        width="26"
        height="26"
        x="0"
        y="0"
        maskUnits="userSpaceOnUse"
      >
        <path fill="#D9D9D9" d="M0 0H26V26H0z"></path>
      </mask>
      <g mask="url(#mask0_4907_15784)">
        <path
          fill={fill}
          fillRule="evenodd"
          d="M22.06 6.279c-.745.02-1.49.013-2.234.006-.372-.003-.745-.006-1.117-.006h-1.101v-.33c0-.175 0-.351.002-.527.003-.526.006-1.05-.017-1.566-.062-1.091-.964-2.003-2.08-2.033a90.72 90.72 0 00-4.942 0c-1.01.015-1.82.732-2.065 1.69a3.029 3.029 0 00-.068.592c-.003.053-.005.104-.009.155v2.019H3.84c-.474 0-.887.284-1.055.702-.168.419-.077.927.275 1.197.164.128.367.218.57.308.081.036.162.072.24.11a.211.211 0 01.031-.022c.012-.008.023-.015.031-.023 0 .014.003.027.007.042.004.018.008.038.008.063.062.912.127 1.824.192 2.736.065.912.13 1.825.19 2.737.082 1.125.167 2.25.251 3.376.092 1.21.183 2.42.27 3.636.107 1.57 1.499 3.006 3.105 3.02 3.366.046 6.731.046 10.096 0 1.484-.014 2.815-1.196 3.06-2.63.107-.604.149-1.225.191-1.842l.038-.536c.053-.662.098-1.324.143-1.984.047-.682.094-1.362.148-2.039a7498.77 7498.77 0 00.367-4.994c.023-.261.042-.527.061-.792.02-.266.039-.531.061-.793a.284.284 0 00.065-.008c.015-.004.029-.007.043-.007.734-.104 1.147-.553 1.116-1.226-.03-.508-.505-1.046-1.254-1.031h-.03zM10.74 4.066h4.527v2.213H10.74V4.066zm8.963 5.696c-.038.554-.08 1.107-.122 1.66-.042.553-.084 1.107-.122 1.66a367.64 367.64 0 00-.153 2.063c-.05.688-.1 1.376-.153 2.064l-.115 1.62-.115 1.624c0 .135-.014.27-.028.399-.007.058-.013.114-.017.17-.062.463-.46.837-.918.897-.107.015-.23.03-.352.03H8.429c-.627 0-1.04-.24-1.208-.718-.06-.145-.076-.319-.09-.48l-.002-.013c-.092-1.331-.183-2.662-.29-4.008a361.026 361.026 0 00-.306-4.052c-.092-1.3-.184-2.602-.291-3.902V8.52H19.78c-.015.204-.026.404-.037.602-.012.21-.024.417-.04.625v.014zm-9 9.96c.673 0 1.178-.479 1.178-1.167v-6.639c0-.658-.52-1.166-1.163-1.166s-1.132.508-1.132 1.181v6.609c0 .673.474 1.181 1.117 1.181zm4.6 0h-.007.015-.008zm1.14-1.167c0 .67-.486 1.163-1.14 1.166-.654-.003-1.155-.48-1.155-1.15v-6.64c0-.673.505-1.181 1.148-1.181.658 0 1.147.508 1.147 1.196v6.609z"
          clipRule="evenodd"
        ></path>
      </g>
    </svg>
  );
}

export default Icon;
